/**
 *
 * Featured articles plugin for Malina 6.9 CMS
 * author: Andrej Krajci <www.andrejkrajci.net>
 * package: sk.teraz.www
 * version: 2010_10_17
 */
(function ($) {
    var FeaturedArticles = function () {
        var
            currentViewport = 0,
            timer,
            switchViewport = function (position) {
                /*
                 * Bullets
                 */
                $("#FeaturedArticles_bullets a").removeClass("dot_act").addClass("dot_not");
                $("#FeaturedArticles_bullets a:eq(" + position + ")").addClass("dot_act").removeClass("dot_not");

                $("#FeaturedArticles_viewport").stop().animate({ 'left':(221 * 4 * position - 55) * (-1)}, 700);

                currentViewport = position;

                /*
                 * Autoswitch
                 */
                if (timer != false) {
                    if (currentViewport == 2)
                        next = 0;
                    else
                        next = currentViewport + 1;

                    timer = setTimeout("$.fn.FeaturedArticles({'action':'switchViewport','viewport':" + next + "})", 15000);
                }
            },
            init = function () {
                /*
                 * Bullets
                 */
                $("#FeaturedArticles_bullets a").each(function (i, el) {
                    $(this).mouseover(function () {
                        clearTimeout(timer);
                        timer = false;
                        switchViewport(i);
                        return false;
                    });
                });

                $(".choddoprava").click(function () {
                    clearTimeout(timer);
                    timer = false;

                    if (currentViewport == 2)
                        next = 0;
                    else
                        next = currentViewport + 1;

                    switchViewport(next);

                    return false;
                });

                $(".choddolava").click(function () {
                    clearTimeout(timer);
                    timer = false;

                    if (currentViewport == 0)
                        next = 2;
                    else
                        next = currentViewport - 1;

                    switchViewport(next);

                    return false;
                });

                $(function () {
                    timer = setTimeout("$.fn.FeaturedArticles({'action':'switchViewport','viewport':1})", 15000);
                });
            };

        return {
            bootstrap:function (params) {
                if (typeof(params) == "object") {
                    if (params.action == "switchViewport")
                        switchViewport(params.viewport);
                }
                else
                    init();
                return;
            }
        };
    }();
    $.fn.extend({
        FeaturedArticles:FeaturedArticles.bootstrap
    });
})(jQuery);
